import { createSlice } from "@reduxjs/toolkit";
import { validazioneActions } from "../actions";
  
  export const validazioneSlice = createSlice({
    name: 'validazione',
    initialState:{
        validato: {},
        error: [],
        mesiValidati: [],
        mesiCorsoValidati: null,
        validationLog: {},
        svalidazioneEnd: false,
        eliminato: false
    },
    reducers: {
        initValidati(state) {
            state.validato = {};
            state.error = [];
            state.mesiValidati = [];
            state.mesiCorsoValidati = null;
            state.validationLog = {};
            state.svalidazioneEnd = false;
            state.eliminato = false;
        },
        validaSuccess(state, action) {
            state.validato = action.payload
        },
        resetMesiValidati(state) {
            state.mesiValidati = [];
            state.error = [];
        },
        recuperaValidatiEnd(state, action) {
            state.mesiValidati = action.payload.validation;
            state.error = action.payload.validationError;
        },
        removeValidationEnd(state) {
            state.svalidazioneEnd = true
        },
        ricercaValidazioniSuccess(state, action) {
            state.mesiCorsoValidati = action.payload
        },
        getValidazioniMonitoraggioLogSuccess(state, action) {
            state.validationLog = action.payload
            state.error = []
        },
        removeValidationSuccess(state, action) {
          state.mesiCorsoValidati = [];
      },
    },
    extraReducers: (builder) => {
      // builder.addCase(validazioneActions.validazioneEliminaCorso.fulfilled, (state, action) => {
      //   // state.mesiValidati = action.payload
      // })
      builder.addCase(validazioneActions.validazioneEliminaCorso.rejected, (state, action) => {
        state.validationLog = action.error.message
      })
    },
  })

  export const {
    initValidati,
    validaSuccess,
    recuperaValidatiEnd,
    removeValidationEnd,
    ricercaValidazioniSuccess,
    getValidazioniMonitoraggioLogSuccess,
    removeValidationSuccess,
    resetMesiValidati
} = validazioneSlice.actions;

export default validazioneSlice.reducer
